import { MediumText, Paragraph } from "App/global-style";
import { TransparentBox, TransparentSurface } from "./styled";

import React from "react";
import { Message } from "./interfaces";

type Props = {
  id?: string;
  variant?: "white" | "transparent";
} & Message;

export const MessageBox = ({
  id,
  title,
  description,
  variant = "transparent",
}: Props): React.ReactElement => {
  return (
    <TransparentSurface
      id={id}
      display="block"
      variant="border"
      backgroundVariant={variant}
      padding="16px"
      marginTop="8px"
      marginBottom="12px"
      tabIndex={-1}
      role="alert"
    >
      <TransparentBox
        marginBottom={description ? "16px" : "0"}
        backgroundVariant={variant}
      >
        <MediumText>{title}</MediumText>
      </TransparentBox>
      {description && <Paragraph>{description}</Paragraph>}
    </TransparentSurface>
  );
};
